import { type Filter } from '@kijiji/generated/graphql-types'
import { ChevronLeftSmallIcon } from '@kijiji/icons/src/icons'
import { theme } from '@kijiji/theme'
import { useTranslation } from 'next-i18next'

import { TRANSLATION_KEYS } from '@/constants/localization'
import {
  QuickFilterButtonStyles,
  QuickFilterButtonText,
} from '@/features/filters/components/QuickFilters/styled'
import { getQuickFilterLabel } from '@/features/filters/utils/getQuickFilterLabel'
import { isFilterApplied } from '@/features/filters/utils/isFilterApplied'
import { Flex } from '@/ui/atoms/flex'

type QuickFilterButtonProps = {
  filter: Filter
  onClick: () => void
}

export const QuickFilterButton = ({ filter, onClick }: QuickFilterButtonProps) => {
  const isSelected = isFilterApplied(filter)
  const { t } = useTranslation([TRANSLATION_KEYS.SRP])
  const label = getQuickFilterLabel(filter, t) ?? filter.label

  return (
    <QuickFilterButtonStyles
      shape="pill"
      size="compact"
      variant="subtle"
      onClick={onClick}
      isSelected={isSelected}
    >
      <Flex
        justifyContent="space-around"
        alignItems="center"
        gap={theme.spacing.mini}
        flexGrow={1}
        style={{ maxWidth: '100%' }}
      >
        <QuickFilterButtonText>{label}</QuickFilterButtonText>
        <ChevronLeftSmallIcon size="xsm" style={{ flexShrink: 0 }} />
      </Flex>
    </QuickFilterButtonStyles>
  )
}
